export default {
    computed: {
        currentUser: function () {
            return this.$store.state.currentUser;
        },
    }
}